import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PackageIcon, MapPinIcon, HeartIcon, TicketIcon, RefreshCwIcon, WalletIcon, StarIcon, HelpCircleIcon } from 'lucide-react';
export function QuickActionsGrid() {
  const navigate = useNavigate();
  const actions = [{
    icon: PackageIcon,
    label: 'Orders',
    count: 5,
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
    badgeColor: 'bg-purple-500',
    path: '/account/orders'
  }, {
    icon: HeartIcon,
    label: 'Wishlist',
    count: 12,
    color: 'text-rose-600',
    bgColor: 'bg-rose-50',
    badgeColor: 'bg-rose-500',
    path: '/account/wishlist'
  }, {
    icon: TicketIcon,
    label: 'Coupons',
    count: 3,
    color: 'text-emerald-600',
    bgColor: 'bg-emerald-50',
    badgeColor: 'bg-emerald-500',
    path: '/account/coupons'
  }, {
    icon: MapPinIcon,
    label: 'Addresses',
    count: 2,
    color: 'text-blue-600',
    bgColor: 'bg-blue-50',
    badgeColor: 'bg-blue-500',
    path: '/account/addresses'
  }, {
    icon: RefreshCwIcon,
    label: 'Returns',
    count: 0,
    color: 'text-orange-600',
    bgColor: 'bg-orange-50',
    badgeColor: 'bg-orange-500',
    path: '/account/returns'
  }, {
    icon: WalletIcon,
    label: 'Wallet',
    count: 0,
    color: 'text-teal-600',
    bgColor: 'bg-teal-50',
    badgeColor: 'bg-teal-500',
    path: '/account/wallet'
  }, {
    icon: StarIcon,
    label: 'Points',
    count: 0,
    color: 'text-amber-600',
    bgColor: 'bg-amber-50',
    badgeColor: 'bg-amber-500',
    path: '/account/points'
  }, {
    icon: HelpCircleIcon,
    label: 'Support',
    count: 0,
    color: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
    badgeColor: 'bg-indigo-500',
    path: '/help-center'
  }];
  return <div className="px-4 mt-4" data-id="element-1065" data-mp="3ktp3q6mzu5ho">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-3" data-id="element-1066" data-mp="2v5bc3jgk3ntr">
        <div className="flex items-center justify-between px-1 pb-2" data-id="element-1067" data-mp="2v375uuv6qcqb">
          <h3 className="text-sm font-bold text-gray-900" data-id="element-1068" data-mp="2q7rxgify591a">Quick Actions</h3>
        </div>
        <div className="grid grid-cols-4 gap-y-3" data-id="element-1069" data-mp="34vwiht2h1wn8">
          {actions.map((action, index) => {
          const Icon = action.icon;
          return <button key={index} onClick={() => navigate(action.path)} className="relative flex flex-col items-center gap-1.5 p-2 rounded-xl active:scale-95 active:bg-gray-50 transition-transform" data-id="element-1070" data-mp="3dvt39jlqqbd0" data-mpi={index}>
                {action.count > 0 && <div className={`absolute top-0 right-2 ${action.badgeColor} text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 ring-2 ring-white`} data-id="element-1071" data-mp="3iv5nrxp536cf">
                    {action.count}
                  </div>}
                <div className={`w-11 h-11 ${action.bgColor} rounded-xl flex items-center justify-center`} data-id="element-1072" data-mp="3ykfdvj50k4f">
                  <Icon className={`w-5 h-5 ${action.color}`} data-id="element-1073" data-mp="90001mhekoma" />
                </div>
                <span className="text-[11px] font-medium text-gray-700 text-center leading-tight" data-id="element-1074" data-mp="3qdvnexi5fmyj">
                  {action.label}
                </span>
              </button>;
        })}
        </div>
      </div>
    </div>;
}